import {FormattedMessage, useIntl} from 'react-intl';
import { useSelector } from 'react-redux';
import Auth from '../../logic/redux/auth';
import { withErrorBoundary } from '@sentry/react';
import { Fallback } from '../../components/utils/error-boundary';
import DefaultScreen from '../../components/containers/default-screen';
import { Paths } from '../../navigation/paths';
import { assets } from '../../assets';
import React, {useState} from 'react';
import { BlurredContainer } from '../../components/containers/containers';
import StyledSelect, {SelectOption} from '../../components/inputs/styled-select';
import {useToasts} from "react-toast-notifications";
import { GraphqlOperations } from '../../logic/graphql/operations';
import {useMutation} from "urql";
import Button from "../../components/buttons/button";

const LocaleSettings = (): JSX.Element => {
  const intl = useIntl();
  const language = useSelector(Auth.select.selectAuthToken)?.language;
  const { addToast } = useToasts();

  const changeLanguage = useMutation(
          GraphqlOperations.mutations.update_user_language.mutationString,
  )[1];

  const [selectedLanguage, setSelectedLanguage] = useState<string | undefined>(undefined);

  const handleTimeoutSelectionChange = (option: SelectOption): void => {
    setSelectedLanguage(option.value as string)
  };

  const handleChangeClick = (): void => {
    if (selectedLanguage) {
      const variables = GraphqlOperations.mutations.update_user_language.createVars(selectedLanguage);
      changeLanguage(variables)
        .then((result) => {
          if (result && !result.error) {
            setSelectedLanguage(undefined);
            addToast(
              intl.formatMessage({ id: 'profilePage.settings.localeSettings.toast.success' }),
              {
                appearance: 'success',
                autoDismiss: true,
              },
            );
          } else {
            addToast(
              intl.formatMessage({ id: 'profilePage.settings.localeSettings.toast.error' }),
              {
                appearance: 'error',
                autoDismiss: false,
              },
            );
          }
          return true;
        })
        .catch(() => {
          addToast(intl.formatMessage({ id: 'profilePage.settings.localeSettings.toast.error' }), {
            appearance: 'error',
            autoDismiss: false,
          });
        });
    }
  }

  return (
    <DefaultScreen
      background={assets.images.profile_bg}
      title={intl.formatMessage({ id: 'profilePage.settings.localeSettings.title' })}
      backUrl={Paths.settings}
    >
      <BlurredContainer>
        <p className="text-14 mb-6">
          <FormattedMessage id="profilePage.settings.localeSettings.description"/>
        </p>
        <StyledSelect
                className="mb-8"
                onChange={handleTimeoutSelectionChange}
                initialValue={language}
                options={[
                  {
                    value: 'hu',
                    label: intl.formatMessage({
                      id: 'common.languageSelect.hu',
                    }),
                  },
                  {
                    value: 'en',
                    label: intl.formatMessage({
                      id: 'common.languageSelect.en',
                    }),
                  }
                ]}
        />
        <Button inactive={!selectedLanguage} loading={false} onClick={handleChangeClick}>
          <FormattedMessage id="profilePage.settings.localeSettings.changeButton" />
        </Button>
      </BlurredContainer>
    </DefaultScreen>
  );
};

export default withErrorBoundary(LocaleSettings, {fallback: Fallback});
